import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const CareerAreaOne = () => {
  return (
    <>
      {/* career area start */}
      <div className='career-section pd-top-90'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-6'>
              <div className='section-title text-center'>
                <h2 className='title'>
                  The Power Of <span>Rope Hammer</span> The Simplicity Of Solutions
                </h2>
              </div>
            </div>
          </div>
          <div className='career-wrap-area'>
            <nav>
              <div
                className='nav nav-tabs career-nav-tab w-100 justify-content-around'
                id='nav-tab'
                role='tablist'
              >
                <button
                  className='nav-link active'
                  style={{ width: "50%" }}
                  id='nav-mission-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#nav-mission'
                  type='button'
                  role='tab'
                  aria-controls='nav-mission'
                  aria-selected='true'
                >
                  1-Ton Rope Hammer
                </button>
                <button
                  className='nav-link'
                  style={{ width: "50%" }}
                  id='nav-vision-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#nav-vision'
                  type='button'
                  role='tab'
                  aria-controls='nav-vision'
                  aria-selected='false'
                >
                  2-Ton Rope Hammer
                </button>
              </div>
            </nav>
            <div className='tab-content' id='nav-tabContent'>
              <div
                className='tab-pane fade show active'
                id='nav-mission'
                role='tabpanel'
                aria-labelledby='nav-mission-tab'
              >
                <div className='career-wrap'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <img src='assets/img/about/1ton.jfif' className="img-fluid mb-3 mb-md-0" alt='img' />
                    </div>
                    <div className='col-lg-6'>
                      <h3 className='mb-3'>1-Ton Rope Hammer </h3>
                      <p className='mb-3'>
                      A 1-ton ROP hammer forging closed die is a type of power hammer used in industrial forging processes. It delivers 1 ton of impact force to shape metal workpieces within a closed die, ensuring precision and repeatability.
                      </p>
                      <div className='row'>
                        <div className='col-md-6'>
                          <ul className='single-list-inner style-check style-heading style-check mb-3'>
                            <li>
                              <FaCheckCircle /> Impact Force
                            </li>
                            <li>
                              <FaCheckCircle /> Power Source
                            </li>
                            <li>
                              <FaCheckCircle /> Stroke Length & Speed
                            </li>
                          </ul>
                        </div>
                        <div className='col-md-6'>
                          <ul className='single-list-inner style-check style-heading style-check mb-3'>
                            <li>
                              <FaCheckCircle /> Frame Structure
                            </li>
                            <li>
                              <FaCheckCircle /> Die System
                            </li>
                            <li>
                              <FaCheckCircle /> Automation
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className='tab-pane fade'
                id='nav-vision'
                role='tabpanel'
                aria-labelledby='nav-vision-tab'
              >
                <div className='career-wrap'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <img src='assets/img/about/2ton.jfif' className="img-fluid mb-3 mb-md-0" alt='img' />
                    </div>
                    <div className='col-lg-6'>
                      <h3 className='mb-3'>2-Ton Rope Hammer </h3>
                      <p className='mb-3'>
                      A 2-ton ROP hammer forging closed die is a type of power hammer used in industrial forging processes. It delivers 2 ton of impact force to shape metal workpieces within a closed die, ensuring precision and repeatability.
                      </p>
                      <div className='row'>
                        <div className='col-md-6'>
                          <ul className='single-list-inner style-check style-heading style-check mb-3'>
                            <li>
                              <FaCheckCircle /> Impact Force
                            </li>
                            <li>
                              <FaCheckCircle /> Power Source
                            </li>
                            <li>
                              <FaCheckCircle /> Stroke Length & Speed
                            </li>
                          </ul>
                        </div>
                        <div className='col-md-6'>
                          <ul className='single-list-inner style-check style-heading style-check mb-3'>
                            <li>
                              <FaCheckCircle /> Frame Structure
                            </li>
                            <li>
                              <FaCheckCircle /> Die System
                            </li>
                            <li>
                              <FaCheckCircle /> Automation
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* career area start */}
    </>
  );
};

export default CareerAreaOne;
